<shared-ui-buttons-button
  [icon]="setIcon()"
  [text]="setButtonText()"
  [type]="type"
  [size]="size"
  [disabled]="disabled || isCopied"
  (action)="buttonClicked()"
></shared-ui-buttons-button>
